const {
  VITE_AZURE_AD_TENANT_ID,
  VITE_AZURE_AD_CLIENT_ID,
  VITE_AZURE_AD_REDIRECT_URI,
} = import.meta.env;


function required(name, value) {
  if (!value) {
    throw new Error(`Missing ${name}. Set it as an Azure DevOps pipeline variable or in your local .env for dev.`);
  }
  return value;
}

export const msalConfig = {
  auth: {
    clientId: required("VITE_AZURE_AD_CLIENT_ID", VITE_AZURE_AD_CLIENT_ID),
    authority: `https://login.microsoftonline.com/${required(
      "VITE_AZURE_AD_TENANT_ID",
      VITE_AZURE_AD_TENANT_ID
    )}`,

    redirectUri: VITE_AZURE_AD_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
